import { NgModule } from "@angular/core";
import { IonicModule } from "ionic-angular";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { TextareaControlComponent } from "./textarea-control.component";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        TextareaControlComponent
    ],
    exports: [
        TextareaControlComponent
    ]
})
export class TextareaControlModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/textarea/form/textarea-control.module.ts